import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@paulownia/shared/components/ui/dialog';
import { Button } from '@paulownia/shared/components/ui/button';
import { AlertTriangle } from 'lucide-react';

interface MarketChangeModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  merchantName: string;
  onConfirm: () => void;
}

/**
 * Confirmation modal shown when changing market would clear
 * the cart for a specific merchant.
 */
export function MarketChangeModal({
  open,
  onOpenChange,
  merchantName,
  onConfirm,
}: MarketChangeModalProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <AlertTriangle className="w-5 h-5 text-amber-500" />
            Changer de marche
          </DialogTitle>
        </DialogHeader>
        <div className="py-4">
          <p className="text-gray-700">
            Changer de marche supprimera les produits de votre panier chez{' '}
            <span className="font-semibold">{merchantName}</span>.
          </p>
        </div>
        <div className="flex gap-3 justify-end">
          <Button
            variant="outline"
            onClick={() => onOpenChange(false)}
          >
            Annuler
          </Button>
          <Button
            onClick={() => {
              onConfirm();
              onOpenChange(false);
            }}
            className="bg-orange-600 hover:bg-orange-700"
          >
            Continuer
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
